import cn from "classnames"
import { useState } from "react"

import { Button, Divider, Flex, Tag, Text } from "@/atoms"
import { Trans, useTranslation } from "@/hooks/useTranslation"
import { EditOutlined } from "@/icons"
import { InformationAlert } from "@/molecules/InformationAlert"
import { Form } from "@/organisms/Form"
import { useAiPolicies } from "@/pages/GovernancePage/applications/policies/useAiPolicies"
import { AiPolicyForm } from "@/pages/GovernancePage/components/pages/AiPolicyPage/components/AiPolicyForm"
import { RuleCardList } from "@/pages/GovernancePage/components/pages/AiPolicyPage/components/RuleCardList"
import { DrawerFormFooter } from "./DrawerFormFooter"
import { EffectivePolicyHeader } from "./EffectivePolicyHeader"

import styles from "./AiPolicyTabAgentAiDiscoveryDrawer.module.scss"

export const Tab = (props: {
  record?: { id?: string }
  agent: { id: string; name: string }
}) => {
  const { response } = useAiPolicies()
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.harden"
  })
  const [isEditing, setIsEditing] = useState(false)
  const stored = response?.data?.[0]
  const record = stored?.type === "heading" ? undefined : stored
  const editing = isEditing ? record : undefined

  if (!record) return null

  const stopEditing = () => setIsEditing(false)

  return (
    <Flex vertical className="container-agent-ai-discovery-drawer">
      {editing && (
        <Flex vertical gap={10}>
          <Flex align="center" justify="space-between">
            <Flex align="center" gap={10}>
              <Text>AI Policy</Text>
              <Tag className={styles.tagEdit}>Edit mode</Tag>
            </Flex>
          </Flex>
          <InformationAlert
            className={styles.alert}
            type="info"
            palette="info"
            message={
              <Trans>{`You are editing <strong>${editing.name}</strong> policy. By saving you will override the AI policy for this agent only`}</Trans>
            }
          />
        </Flex>
      )}
      {!editing && record && (
        <Flex align="center" justify="space-between" gap={16}>
          <EffectivePolicyHeader record={record} />
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => setIsEditing(true)}
          >
            {t("editPolicy")}
          </Button>
        </Flex>
      )}
      <Divider className={cn(styles.rule, editing && styles.divider)} />
      {editing && (
        <Form.Page
          id="ai-policy-form"
          aside={null}
          header={null}
          footer={null}
          Component={({ children }) => (
            <Flex vertical>
              {children}
              <DrawerFormFooter onCancel={stopEditing} />
            </Flex>
          )}
        >
          <AiPolicyForm
            record={editing}
            agent={props.agent}
            mode="drawer"
            setUpdating={(updating) => {
              if (!updating) stopEditing()
            }}
          />
        </Form.Page>
      )}
      {!editing && record && (
        <RuleCardList agentId={props.record?.id} record={record} />
      )}
    </Flex>
  )
}
